<div id="base_r" [ngClass]="{wi_0: close_}" class="right_content bg-white d-flex align-items-stretch">
  <div class="position-absolute d-flex align-items-center h-100">
    <button class="p-0 m-0 border-0 close_r" (click)="close_rigth()">
      <i class="fas fa-angle-double-right" [ngClass]="{rtte: close_}"></i>
    </button>
  </div>
  <div class="container-fluid ancho_">
    <div class="p-2">

      <div class="row">
        <div class="col-md-6">
          <p class="text-title">Asignado</p>
        </div>
        <div class="col-md-6">
          <p class="text-name">{{asignado}}</p>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6">
          <p class="text-title">Solicitante:</p>
        </div>
        <div class="col-md-6">
          <p class="text-name">{{solicitante}}</p>
        </div>
      </div>

      <div class="row mb-3" *inproviderPermmission="['flows.ai', 'trackvision.ai','flows.admin']">
        <div class="col-md-12 text-center">
          <button type="button" class="btn btn-outline-primary rounded-pill px-4 font-weight-bold btn-ai btn-legal-analytics-ai"
            [disabled]="analisys_submitted"
            (click)="aiPrompt()">
            <svg viewBox="0 0 14 17" class="sparkles">
              <path
                d="M6.417 4.074c.096 0 .157-.061.178-.157.191-1.114.184-1.128 1.36-1.36.096-.02.157-.076.157-.178 0-.096-.061-.157-.157-.171-1.176-.219-1.155-.24-1.36-1.36-.02-.096-.082-.164-.178-.164-.096 0-.157.068-.178.164-.205 1.107-.177 1.12-1.36 1.36-.096.014-.157.075-.157.17 0 .103.061.158.164.179 1.169.225 1.162.232 1.353 1.36.02.096.082.157.178.157zM3.095 8.921c.15 0 .266-.11.287-.253.232-1.798.28-1.812 2.167-2.16a.276.276 0 00.246-.28c0-.15-.11-.267-.253-.28-1.873-.26-1.928-.315-2.16-2.154-.02-.15-.13-.26-.287-.26-.15 0-.26.11-.28.267-.22 1.798-.294 1.798-2.168 2.146-.15.02-.252.13-.252.28 0 .158.102.26.28.28 1.846.288 1.92.35 2.14 2.147.02.158.13.267.28.267zm4.82 7.54c.211 0 .375-.15.41-.376.498-3.67 1.01-4.252 4.655-4.662a.416.416 0 00.39-.41c0-.22-.165-.383-.39-.417-3.61-.431-4.123-.957-4.656-4.662-.04-.22-.198-.37-.41-.37-.212 0-.376.15-.41.37-.5 3.677-1.012 4.258-4.655 4.662-.226.027-.39.198-.39.417 0 .212.164.383.39.41 3.602.492 4.101.964 4.655 4.662.04.226.198.376.41.376z">
              </path>
            </svg>
            Resumen IA
            @if (analisys_submitted) {
              <span class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
            }
          </button>
        </div>
      </div>

      @if (haveIaDocument) {
        <div class="row mb-3">
          <div class="col-md-12 text-center">
            <button type="button" [disabled]="loadingIA"
              class="btn btn-ia btn-outline-primary rounded-pill px-4 font-weight-bold btn-ai"
              (click)="generateIADocument()">
              <svg viewBox="0 0 14 17" class="sparkles">
                <path
                  d="M6.417 4.074c.096 0 .157-.061.178-.157.191-1.114.184-1.128 1.36-1.36.096-.02.157-.076.157-.178 0-.096-.061-.157-.157-.171-1.176-.219-1.155-.24-1.36-1.36-.02-.096-.082-.164-.178-.164-.096 0-.157.068-.178.164-.205 1.107-.177 1.12-1.36 1.36-.096.014-.157.075-.157.17 0 .103.061.158.164.179 1.169.225 1.162.232 1.353 1.36.02.096.082.157.178.157zM3.095 8.921c.15 0 .266-.11.287-.253.232-1.798.28-1.812 2.167-2.16a.276.276 0 00.246-.28c0-.15-.11-.267-.253-.28-1.873-.26-1.928-.315-2.16-2.154-.02-.15-.13-.26-.287-.26-.15 0-.26.11-.28.267-.22 1.798-.294 1.798-2.168 2.146-.15.02-.252.13-.252.28 0 .158.102.26.28.28 1.846.288 1.92.35 2.14 2.147.02.158.13.267.28.267zm4.82 7.54c.211 0 .375-.15.41-.376.498-3.67 1.01-4.252 4.655-4.662a.416.416 0 00.39-.41c0-.22-.165-.383-.39-.417-3.61-.431-4.123-.957-4.656-4.662-.04-.22-.198-.37-.41-.37-.212 0-.376.15-.41.37-.5 3.677-1.012 4.258-4.655 4.662-.226.027-.39.198-.39.417 0 .212.164.383.39.41 3.602.492 4.101.964 4.655 4.662.04.226.198.376.41.376z">
                </path>
              </svg>
              <span>Informe Sociedad y Poderes</span>
              &nbsp;&nbsp;@if (loadingIA) {
              <span class="spinner-border spinner-border-sm" role="status"
              aria-hidden="true"></span>
            }</button>
          </div>
        </div>
      }


      <!-- <div class="row mb-2 mp-2 div-applicant">
      <div class="col-md-10">
        <p class="text-title">Abogado Solicitante:&nbsp;&nbsp;{{solicitante}}</p>
      </div>
      <div class="col-md-1">
        <div class="dropdown">
          <div ngbDropdown [open]="false" [autoClose]="true" class="d-inline-block">
            <i data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="dropdownBasic1"
              dropdown-menu dropdown-menu-left show ngbDropdownToggle (click)="$event.stopPropagation();"
            class="dropdown-toggle fas fa-ellipsis-v "></i>
            <div class="dropdown-menu" ngbDropdownMenu="dropdownBasic1">

              <a class="dropdown-item icon-table">
                <i class="far fa-trash-alt"></i>
                Eliminar Requerimiento
              </a>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="row mb-3">
      <div class="col-md-12 text-center" *inproviderPermmission="['flows.requirement.delete','flows.admin']">
        @if (requirement['candelete']) {
          <button type="button"
            class="btn btn-outline-primary bg-danger rounded-pill text-white px-4 font-weight-bold"
          (click)="deleteRequirement()">Eliminar Requerimiento</button>
        }
      </div>
    </div>

    <div class="accordion" id="verticalAccordion">
      <!--ADJUNTOS-->
      @if (containsText('fas fa-paperclip')) {
        <div class="">
          <div class="div-accordion-link pointer-cursor" id="headingOne" data-toggle="collapse"
            data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            <div class="row">
              <div class="col-md-10">
                <i class="fa-paperclip fas"></i>
                &nbsp;Archivos
              </div>
              <div class="col-md-2">
                <button class="btn btn-link" type="button">
                  <i class="fas fa-chevron-down"></i>
                </button>
              </div>
            </div>
          </div>
          <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#verticalAccordion">
            <br>
              <div class="col-md-12  files-req">
                <div class="row">
                  <div class="col-md-7 pr-3">
                    <div class="title-style" data-cy="archivos"></div>
                  </div>
                  <div class="col-md-4">
                    <div class="row justify-content-end">
                      @if (files && files.length > 0) {
                        <div class="col-xs-5 icon-plus mr-3">
                          <a type="button" class="icon-doc" data-cy="upload-file" (click)="downloadFiles()"
                            data-toggle="tooltip" data-placement="top" title="Descarga todos los Documentos">
                            <i class="fas fa-arrow-circle-down"></i>
                          </a>
                        </div>
                      }
                      <div class="col-xs-5 icon-plus">
                        <a type="button" class="icon-doc" data-cy="upload-file" (click)="uploadFile()">
                          <i class="fas fa-upload"></i>
                        </a>
                      </div>
                      <div class="col-md-1 pl-1 pr-1"></div>
                    </div>
                  </div>
                </div>
                <!-- Conexión con Google Drive. Va en su propia fila y no en la de iconos:
                     esa fila mide ~107px y no admite un tercer icono sin partirse. -->
                <div class="row mb-2">
                  <div class="col-md-12">
                    @if (driveConnected) {
                      <!-- Solo estado. Desvincular se hace en el perfil (Vincular cuentas),
                           porque la conexión de Google es una sola: identidad + Drive. -->
                      <small class="d-flex align-items-center" data-cy="drive-connected"
                        [class.text-muted]="!driveForeignAccount"
                        [class.text-warning]="driveForeignAccount"
                        [title]="driveForeignAccount
                          ? 'El Drive conectado (' + driveEmail + ') no es el tuyo. Los archivos que envíes van a esa cuenta. Para cambiarlo, ve a tu perfil › Vincular cuentas.'
                          : 'Cuenta de Google conectada: ' + driveEmail + '. Para desvincularla, ve a tu perfil › Vincular cuentas.'">
                        <i class="fab fa-google-drive mr-1" [class.text-success]="!driveForeignAccount"
                          [class.text-warning]="driveForeignAccount"></i>
                        <span class="text-truncate">Drive: {{driveEmail}}</span>
                      </small>
                      <!-- El aviso va con el nombre de la cuenta a la vista: la credencial queda
                           pegada al usuario y no a la persona, así que en una cuenta compartida
                           el archivo se sube al Drive de quien la conectó primero. -->
                      @if (driveForeignAccount) {
                        <small class="d-block text-warning" data-cy="drive-foreign-account">
                          <i class="fas fa-exclamation-triangle mr-1"></i>Esta cuenta de Drive no es tuya. Lo que envíes queda en ese Drive.
                        </small>
                      }
                    } @else {
                      <a role="button" class="btn btn-link btn-sm p-0" data-cy="drive-connect" (click)="connectDrive()">
                        <i class="fab fa-google-drive mr-1"></i>Conectar cuenta de Google
                      </a>
                    }
                  </div>
                </div>
                @if (filesLoading) {
                  <div class="d-flex justify-content-center">
                    <table class="table-borderless" style="table-layout: fixed; width: 100%;">
                      <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </table>
                  </div>
                }
                @if (!filesLoading) {
                  <div class="attachment-container">
                    @for (file of files; track file; let i = $index) {
                      <div [attr.data-id]="'ttachment-board-'+i"
                        [attr.data-order]="i" class="attachment-board "
                        style="width: 250px; margin-left: 15px; margin-right: 15px;">
                        <header class="attachment-board-header">
                          <div class="attachment-board-header-main">
                            <div
                              [attr.data-text]="file.filename"
                              class="attachment-title-board"
                              [ngbTooltip]="file.filename"
                              container="body"
                              placement="top"
                              >
                              {{file.filename}}
                            </div>
                            @if (file.category) {
                              <div
                                class="attachment-category-badge"
                                [ngClass]="attachmentCategoryClass(file.category)"
                                [title]="attachmentCategoryDisplay(file)"
                                >
                                {{ attachmentCategoryDisplay(file) }}
                              </div>
                            }
                            @if (file.lastEdit) {
                              <div class="text-muted small" style="font-size:11px;margin-top:2px;">
                                Modificado por {{file.lastEdit.username}} el {{file.lastEdit.editedAt | date:'dd/MM/yyyy HH:mm'}}
                              </div>
                            }
                          </div>
                          <div class="dropdown">
                            <div ngbDropdown [open]="false" [autoClose]="true" class="d-inline-block">
                              <i data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="dropdownBasic1"
                                dropdown-menu dropdown-menu-left show ngbDropdownToggle (click)="$event.stopPropagation();"
                              class="dropdown-toggle fas fa-ellipsis-v "></i>
                              <div class="dropdown-menu" ngbDropdownMenu="dropdownBasic1">
                                @if (file.filename.indexOf('.docx') !== -1 || file.filename.indexOf('.xlsx') !== -1 || file.filename.indexOf('.pptx') !== -1 || file.filename.indexOf('.odt') !== -1 || file.filename.indexOf('.ods') !== -1 || file.filename.indexOf('.odp') !== -1 || file.filename.indexOf('.rtf') !== -1 || file.filename.indexOf('.csv') !== -1) {
                                  <a class="dropdown-item icon-table" (click)="editOnline(file.id)">
                                    <i class="fas fa-edit"></i>
                                    <strong>Editar Online</strong>
                                  </a>
                                  <div class="dropdown-divider"></div>
                                  <a class="dropdown-item icon-table text-muted" (click)="viewOnline(file.id)">
                                    <i class="far fa-eye"></i>
                                    Ver Online (solo lectura)
                                  </a>
                                } @else {
                                  <a class="dropdown-item icon-table" target="_blank" href="{{file.urlView}}">
                                    <i class="far fa-eye"></i>
                                    Ver
                                  </a>
                                }
                                <a class="dropdown-item icon-table" target="_blank" href="{{file.url}}">
                                  <i class="fas fa-download"></i>
                                  Descargar
                                </a>
                                @if (driveConnected) {
                                  <a class="dropdown-item icon-table" (click)="sendToDrive(file)"
                                    [class.disabled]="file.driveSending">
                                    <i class="fab fa-google-drive"></i>
                                    @if (file.driveSending) {
                                      Enviando a Google Drive…
                                    } @else {
                                      {{ file.drive ? 'Reenviar a Google Drive' : 'Enviar a Google Drive' }}
                                    }
                                  </a>
                                } @else {
                                  <a class="dropdown-item icon-table text-muted" (click)="connectDrive()">
                                    <i class="fab fa-google-drive"></i>
                                    Conectar Google para editar en Drive
                                  </a>
                                }
                                @if (file.drive && file.drive.driveUrl) {
                                  <a class="dropdown-item icon-table" target="_blank" href="{{file.drive.driveUrl}}">
                                    <i class="fas fa-external-link-alt"></i>
                                    Abrir en Google Docs
                                  </a>
                                  <a class="dropdown-item icon-table" (click)="pullFromDrive(file)"
                                    [class.disabled]="file.drivePulling">
                                    <i class="fas fa-cloud-download-alt"></i>
                                    @if (file.drivePulling) {
                                      Trayendo cambios…
                                    } @else {
                                      Traer cambios desde Google
                                    }
                                  </a>
                                  @if (file.drive.editedLocallyAfterSend) {
                                    <span class="dropdown-item icon-table text-warning" style="font-size: 11px; cursor: default;">
                                      <i class="fas fa-exclamation-triangle"></i>
                                      Editado en la plataforma luego de enviarse a Drive
                                    </span>
                                  }
                                }
                                @if (enableAttachmentCategories) {
                                  <a class="dropdown-item icon-table" (click)="editCategory(file)">
                                    <i class="fas fa-tag"></i>
                                    Editar categoría
                                  </a>
                                }
                                <a class="dropdown-item icon-table" (click)="deleteItem(file.id)">
                                  <i class="far fa-trash-alt"></i>
                                  Eliminar
                                </a>
                              </div>
                            </div>
                          </div>
                        </header>
                        @if (file.note && file.note !== 'undefined') {
                          <main class="attachment-drag">
                            <div class="">
                              <app-notes [dataNote]="[file]"></app-notes>
                            </div>
                          </main>
                        } @else {
                          <main class="attachment-drag">
                            <div class="notes-footer d-flex justify-content-between align-items-end mt-1 px-1 pb-1">
                              <div class="notes-footer-left d-flex align-items-center">
                                <div class="notes-due-date mr-5">
                                  <i class="far fa-clock font-size-small mr-1"></i>
                                  @if (file.date) {
                                    <span class="font-size-small">{{ file.date | date:'MMM d, y h:mm a':'':'en-US' }}</span>
                                  }
                                </div>
                              </div>
                              <div class="notes-footer-right">
                                <div class="notes-users">
                                  <ul class="list-unstyled users-list cursor-pointer m-0 d-flex align-items-center">
                                    <li class="avatar pull-up my-0 " triggers="click" placement="left" [ngbTooltip]="file.name">
                                      <app-avatar-photo [photoUrl]="undefined" [name]="file.name"></app-avatar-photo>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </main>
                        }
                      </div>
                    }
                    @if (files?.length <= 0) {
                      <app-without-registration [icon]="'fas fa-paperclip'"
                        [text]="'Sin Adjuntos'">
                      </app-without-registration>
                    }
                  </div>
                }
              </div>
            </div>
            <br>
            </div>
          }
          <!--ACTIVIDADES Y ALERTAS-->
          @if (containsText('far fa-clock')) {
            <div class="">
              <div class="div-accordion-link pointer-cursor" id="headingOne" data-toggle="collapse"
                data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                <div class="row">
                  <div class="col-md-10">
                    <i class="fa-clock far"></i>
                    &nbsp;Actividades y Alertas
                  </div>
                  <div class="col-md-2">
                    <button class="btn btn-link" type="button">
                      <i class="fas fa-chevron-down"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#verticalAccordion">
                <br>
                  <div class="col-md-12  alerts-req">
                    <div class="row">
                      <!-- <div class="col-md-9">
                      <div class="title-style"></div>
                    </div>
                    <div class="col-md-1 pl-0"></div>
                    <div class="col-xs-2 icon-plus">
                      <a type="button" class="icon-doc" (click)="openAlertModule(null)">
                        <i class="fas fa-plus"></i>
                      </a>
                    </div> -->
                    <div class="col-md-6 col-lg-6 col-sm-6 activities-title-board">
                      <span class="activities-subtitle-justify">{{actvAlertHistory ? actvAlertHistory.length+' Actividades' : '0 Actividades'}} </span>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-6 d-flex justify-content-end"> <button type="button"
                      class="btn btn-outline-primary-add rounded-pill px-4 font-weight-bold"
                      (click)="openAlertModule(null)"> <i class="fas fa-plus"></i> Agregar </button> </div>
                    </div>
                    @if (alertLoading) {
                      <div class="d-flex justify-content-center">
                        <table class="table-borderless" style="table-layout: fixed; width: 100%;">
                          <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </table>
                      </div>
                    }
                    @if (!alertLoading) {
                      <div class="activities-containers" style="margin-bottom: 68px;">
                        @for (actvAler of actvAlertHistory; track actvAler.activity.id; let i = $index) {
                          <div [attr.data-id]="'activities-board-'+i"
                            [attr.data-order]="i" class="activities-board "
                            style="width: 250px; margin-left: 15px; margin-right: 15px;">
                            <header class="activities-board-header">
                              <div class="activities-title-board  d-flex justify-content-between">
                                <div class="truncate">
                                  <span class="activities-subtitle-justify">{{actvAler.activity.subject}}</span>
                                </div>
                              </div>
                              @if (actvAler.activity.created_by === currentUserId) {
                                <div class="dropdown">
                                  @if (!actvAler.activity.completedActivity) {
                                    <div ngbDropdown [open]="false" [autoClose]="true" class="d-inline-block"
                                      >
                                      <i data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="dropdownBasic1"
                                        dropdown-menu dropdown-menu-left show ngbDropdownToggle (click)="$event.stopPropagation();"
                                      class="dropdown-toggle fas fa-ellipsis-v "></i>
                                      <div class="dropdown-menu" ngbDropdownMenu="dropdownBasic1">
                                        <a class="dropdown-item icon-table" target="_blank"
                                          (click)="openAlertModule(actvAler.activity.id)">
                                          <i class="fas fa-edit"></i>
                                          Editar
                                        </a>
                                        <a class="dropdown-item icon-table" (click)="deleteAlert(actvAler.activity.id)">
                                          <i class="far fa-trash-alt"></i>
                                          Eliminar
                                        </a>
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                            </header>
                            <div class=" activities-content">
                              <div class="activities-content-item">
                                <div class="activities-content-board truncate">
                                  <span class="activities-subtitle activities-text">
                                    {{actvAler.activity.content}}
                                  </span>
                                </div>
                                <div class="activities-content-footer d-flex justify-content-between align-items-end mt-1">
                                  <div class="activities-content-footer-left d-flex align-items-center">
                                    <div class="activities-content-due-date mr-1">
                                      <i class="far fa-clock font-size-small mr-1"></i>
                                      <span class="font-size-small">
                                        @if (actvAler.activity | activityInstant) {
                                          {{ actvAler.activity | activityInstant | formatInstant:'mediumDate' }} -
                                          {{ actvAler.activity | activityInstant | formatInstant:'shortTime' }}
                                        }
                                      </span>
                                      <!-- <button [ngbPopover]="calendarTemplate1" placement="bottom" class="opt_btn ml-2"
                                      style="border:none">
                                      <i class="fas fa-calendar-alt font-size-small mr-1"></i>
                                    </button> -->
                                    <ng-template #calendarTemplate1>
                                      <app-calendar-programming
                                        [titulo]="'ID ' + requirementId + ': ' + actvAler.activity.subject"
                                        [details]="uri" [startDate]="activityCalendarStartDate(actvAler.activity)"
                                        [hourStart]="activityCalendarHourStart(actvAler.activity)" [showInModal]="true"
                                      [data]="actvAler"></app-calendar-programming>
                                    </ng-template>
                                  </div>
                                </div>
                                <!-- <div class="activities-content-footer-right">
                                <div class="activities-content-collaborator scroll-activve">
                                  <ul class="list-unstyled  list-collaborator cursor-pointer m-0 d-flex align-items-center">
                                    <ng-container *ngIf="actvAler.collaborator.length <= 3; else blockelse">
                                      <li class="avatar pull-up my-0 " triggers="click" placement="left"
                                        [ngbTooltip]="actvColl.name"
                                        *ngFor="let actvColl of actvAler.collaborator; let i = index">
                                        <app-avatar-photo [photoUrl]="undefined" [name]="actvColl.name"></app-avatar-photo>
                                      </li>
                                    </ng-container>
                                    <ng-template #blockelse>
                                      <li class="avatar pull-up my-0 " triggers="click" placement="left"
                                        [ngbTooltip]="actvAler.collaborator[i].name"
                                        *ngFor="let number of [0,1,2];let i= index">
                                        <app-avatar-photo [photoUrl]="undefined" [name]="actvAler.collaborator[i].name">
                                        </app-avatar-photo>
                                      </li>
                                      <li class="avatar avatar-sm"><span class="badge badge-info">
                                      +{{actvAler.collaborator.length - 3}} más</span>
                                    </li>
                                  </ng-template>
                                </ul>
                              </div>
                            </div> -->
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-lg-12 col-sm-12">
                        <app-calendar-programming
                          [titulo]="'ID ' + requirementId + ': ' + actvAler.activity.subject"
                          [details]="uri" [startDate]="activityCalendarStartDate(actvAler.activity)"
                          [hourStart]="activityCalendarHourStart(actvAler.activity)" [showInModal]="false"
                        [data]="actvAler"></app-calendar-programming>
                      </div>
                      <div class="row mt-2">
                        <div class="col-md-7 col-lg-7 col-sm-7">
                          <span [ngbPopover]="calendarColaborador" placement="left" continer="body"
                            popoverClass="custom-popover" class="ml-2 font-size-bold collaborator-activity-item">
                            <b><i class="far fa-user font-size-small ml-1"></i>Colaboradores
                          #{{actvAler.collaborator.length}}</b>
                        </span>
                        <ng-template #calendarColaborador>
                          <ul class="alert-activity">
                            @for (item of actvAler.collaborator; track item.id; let i = $index) {
                              <li class="alert-activity-item ml-1">
                                {{item.name}}
                              </li>
                            }
                          </ul>
                        </ng-template>
                      </div>
                    </div>
                    <div class="activities-content-board mt-2" style="text-align: end;margin-right: 10px;">
                      @if (actvAler.activity.isexpired && !actvAler.activity.completedActivity) {
                        <div
                          class="d-flex justify-content-end mt-2"> <span [hidden]="actvAler.activity.completedActivity"
                          class="btn btn-activity rounded-pill font-weight-bold activities-subtitle badge activity-bg-danger">
                          Venció
                        </span>
                      </div>
                    }
                    @if (!actvAler.activity.isexpired && !actvAler.activity.completedActivity) {
                      <div
                        class="d-flex justify-content-end mt-2"> <span [hidden]="actvAler.activity.completedActivity"
                        class="btn btn-activity rounded-pill  activities-subtitle badge activity-bg-success">
                        Pendiente
                      </span>
                    </div>
                  }
                  @if (actvAler.activity.completedActivity) {
                    <div class="d-flex justify-content-end mt-2"> <span
                      [hidden]="actvAler.activity.completedActivity"
                      class="btn btn-activity rounded-pill  activities-subtitle badge activity-bg-success">
                      Realizada
                    </span>
                  </div>
                }
                @if (actvAler.activity.completedActivity) {
                  <div class="d-flex justify-content-end mt-2">
                    <span class="btn btn-activity rounded-pill activities-subtitle badge activity-bg-success">
                      Realizada
                    </span>
                  </div>
                }
              </div>
              <div class="row mt-3">
                @if (actvAler.activity) {
                  <div class="col-md-5 col-lg-5 col-sm-5">
                    <ul class="alert-activity">
                      @for (alert of actvAler.alert; track alert.id; let i = $index) {
                        <li class="alert-activity-item ml-1">
                          <span [ngbPopover]="calendarTemplate2" placement="left" continer="body"
                            popoverClass="custom-popover" class="ml-2 font-size-bold">
                            <b><i class="far fa-bell font-size-small ml-1"></i>Alerta #{{i + 1}}</b>
                          </span>
                          <!-- <span class="font-size-bold"><i class="far fa-bell font-size-small mr-1"></i>
                          <b>Alerta #{{i + 1}}:</b>
                          ({{alert.date_before_activity | date:'mediumDate':'UTC'}} -
                        </span> -->
                        <!-- <span class="font-size-bold">{{alert.hour_before_activity}})</span> -->
                        <!--
                        <button [ngbPopover]="calendarTemplate2" placement="left" continer="body" class="opt_btn ml-2"
                          style="border:none; background: transparent;">
                          <i class="fas fa-calendar-alt font-size-small mr-1"></i>
                        </button> -->
                        <ng-template #calendarTemplate2>
                          @if (alert | alertInstant) {
                            ({{ alert | alertInstant | formatInstant:'mediumDate' }} - {{ alert | alertInstant | formatInstant:'shortTime' }})
                          }
                          <app-calendar-programming
                            [titulo]="requirementId + ' Tipo solicitud: ' + actvAler.activity.subject" [details]="uri"
                            [startDate]="alertCalendarStartDate(alert)"
                            [hourStart]="alertCalendarHourStart(alert)"
                          [data]="actvAler"></app-calendar-programming>
                        </ng-template>
                      </li>
                    }
                  </ul>
                </div>
              }
              <div class="col-md-7 col-lg-7 col-sm-7" style="text-align: end;">
                <span [hidden]="actvAler.activity.completedActivity"
                  class="btn btn-outline-primary-btn-activity-check btn-activity rounded-pill font-weight-bold mr-3"
                (click)="completedActivity(actvAler.activity.id)">Marcar como realizada </span>
              </div>
              @if (actvAler.activity.realizadopor) {
                <span class="ml-4 font-size-bold">
                  <b>Realizada por {{actvAler.activity.realizadopor}}</b><br>
                  <b>Fecha de realización {{actvAler.activity.completedAt | date:'medium'}}</b>
                </span>
              }
            </div>
            <br>
            </div>
          }
          @if (actvAlertHistory?.length <= 0) {
            <app-without-registration [icon]="'far fa-bell'"
              [text]="'Sin actividades'">
            </app-without-registration>
          }
        </div>
      }
    </div>
  </div>
</div>
}
<!--NOTAS-->
@if (containsText('far fa-comment')) {
  <div class="">
    <div class="div-accordion-link pointer-cursor" id="headingOne" data-toggle="collapse"
      data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
      <div class="row">
        <div class="col-md-10 mt-2">
          <i class="fa-comment far"></i>
          &nbsp;Notas
        </div>
        <div class="col-md-2">
          <button class="btn btn-link" type="button">
            <i class="fas fa-chevron-down"></i>
          </button>
        </div>
      </div>
    </div>
    @if (containsText('far fa-comment')) {
      <div id="collapseThree" class="collapse" aria-labelledby="headingTwo"
        data-parent="#verticalAccordion">
        <br>
          <div class="col-md-12 ">
            <div class="row">
              <div class="col-md-9">
                <div *ngxPermissionsOnly="['flows.ai','flows.admin']" class="title-style"></div>
              </div>
              <div class="col-md-1 pl-0"></div>
              <div class="col-xs-2 icon-plus">
                <a type="button" class="icon-doc" (click)="createNote(null)">
                  <i class="fas fa-plus"></i>
                </a>
              </div>
            </div>
            @if (noteLoading) {
              <div class="d-flex justify-content-center">
                <table class="table-borderless" style="table-layout: fixed; width: 100%;">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </table>
              </div>
            }
            @if (!noteLoading) {
              <div class="notes-container">
                <app-notes [path]="'trackvision/requirement/deletenote'" [dataNote]="dataNote" [isNote]="true"
                  (editNoteEmit)="createNote($event)" (saveEditNoteEmit)="refreshNote($event)"
                  (deleteNoteEmit)="ondeleteNoteEmit($event)" [dataUser]="dataUser" [requirementid]="requirementId">
                </app-notes>
                @if (dataNote.length <= 0) {
                  <app-without-registration [icon]="'far fa-comment'" [text]="'Sin Notas'">
                  </app-without-registration>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
  <!--COLABORADORES-->
  @if (containsText('far fa-user')) {
    <div class="">
      <div class="div-accordion-link pointer-cursor" id="headingOne" data-toggle="collapse"
        data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
        <div class="row">
          <div class="col-md-10 mt-2">
            <i class="fa-user far"></i>
            &nbsp;Colaboradores
          </div>
          <div class="col-md-2">
            <button class="btn btn-link" type="button">
              <i class="fas fa-chevron-down"></i>
            </button>
          </div>
        </div>
      </div>
      <div id="collapseFour" class="collapse" aria-labelledby="headingTwo" data-parent="#verticalAccordion">
        <br>
          <div class="col-md-12 ">
            <div class="row mb-1">
              <div class="col-md-9">
                <div class="title-style"></div>
              </div>
            </div>
            @if (collaboratorLoading) {
              <div class="d-flex justify-content-center">
                <table class="table-borderless" style="table-layout: fixed; width: 100%;">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </table>
              </div>
            }
            @if (thisHaveAddColaboratorPermission && !collaboratorLoading) {
              <form autocomplete="off" [formGroup]="formCollaborator"
                >
                <div class=" w-100">
                  <div class="row mb-1">
                    <div class="col-md-10">
                      <label class="text-form">Usuario</label>
                      <select class="form-control" name="idsContracts" data-cy="select-simple" formControlName="userid">
                        <option value="">Seleccionar</option>
                        @for (colab of collaborators; track colab.id) {
                          <option [value]="colab.id">
                            {{ colab.text }}
                          </option>
                        }
                      </select>
                      @if (formCollaborator.controls.userid.touched &&
                        formCollaborator.controls.userid.errors?.required) {
                        <div class="text-danger list-unstyled">
                          Usuario es requerido
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="w-100">
                  <div class="row">
                    <div class="col-md-10">
                      <label for="" class="text-form">
                        Motivo o razón
                      </label>
                      <textarea class="form-control style-textarea" rows="2" cols="40" formControlName="reason"
                      maxlength="250"></textarea>
                    </div>
                    <a class="col-xs-2 icon-plus" (click)="openModalToAddCollaborator()" type="button">
                      <div class="icon-doc">
                        <i class="fas fa-plus"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </form>
            }
            @if (!collaboratorLoading) {
              <div class="notes-container">
                <app-collaborator-requirement [dataCollaborator]="usersSuscribed" [requirementId]="requirementId"
                  [isOwner]="isOwner" [isCreator]="isCreator" (deleteCollaboratorEmit)="deleteCollaboratorEmit($event)"
                  [dataUser]="dataUser">
                </app-collaborator-requirement>
                @if (usersSuscribed.length <= 0) {
                  <app-without-registration [icon]="'far fa-user'"
                    [text]="'Sin Colaboradores'">
                  </app-without-registration>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
    <!--TEMPLATES-->
    @if (containsText('fas fa-file-code')) {
      <div class="">
        <div class="div-accordion-link pointer-cursor" id="headingOne" data-toggle="collapse"
          data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
          <div class="row">
            <div class="col-md-10 mt-2">
              <i class="fa-file-code fas"></i>
              &nbsp;Templates
            </div>
            <div class="col-md-2">
              <button class="btn btn-link" type="button">
                <i class="fas fa-chevron-down"></i>
              </button>
            </div>
          </div>
        </div>
        <div id="collapseFive" class="collapse" aria-labelledby="headingTwo" data-parent="#verticalAccordion">
          <br>
            <div class="col-md-12  templates-req">
              <div class="row">
                <div class="col-md-9">
                  <div class="title-style"></div>
                </div>
                <div class="col-md-1 pl-0"></div>
                <div class="col-xs-2 icon-plus">
                  <a type="button" class="icon-doc" data-cy="upload-file" (click)="createTemplates()">
                    <i class="fas fa-upload"></i>
                  </a>
                </div>
              </div>
              @if (noteLoading) {
                <div class="d-flex justify-content-center">
                  <table class="table-borderless" style="table-layout: fixed; width: 100%;">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </table>
                </div>
              }
              @if (!recordsLoading) {
                <div class="notes-container">
                  <app-template-detail [records]="records" (deleteFile)="onDeleteTemplateEmit($event)" [isNote]="true">
                  </app-template-detail>
                  @if (records.length <= 0) {
                    <app-without-registration [icon]="'fas fa-file-code'"
                      [text]="'Sin Templates'">
                    </app-without-registration>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
      <!--FIRMAS-->
      @if (containsText('far fa-edit')) {
        <div class="">
          <div class="div-accordion-link pointer-cursor" id="headingOne" data-toggle="collapse"
            data-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
            <br>
              <div class="row">
                <div class="col-md-10 mt-2">
                  <i class="fa-edit far"></i>
                  &nbsp;Firmas
                  @if (totalSignaturesAvailable !== null) {
                    <span class="badge badge-primary ml-2">
                      {{totalSignaturesAvailable}} disponibles
                    </span>
                  }
                  @if (signatureProvider === 'lexgosign' && lexgosignEnabled) {
                    <span class="badge badge-info ml-2">CLM Sign</span>
                  }
                  @if (signatureProvider === 'docusign') {
                    <span class="badge badge-secondary ml-2">DocuSign</span>
                  }
                </div>
                <div class="col-md-2">
                  <button class="btn btn-link" type="button">
                    <i class="fas fa-chevron-down"></i>
                  </button>
                </div>
              </div>
            </div>
            <div id="collapseSix" class="collapse" aria-labelledby="headingTwo" data-parent="#verticalAccordion">
              <br>
                <div class="col-md-12   sign-req">
                  <div class="row align-items-end mb-2">
                    @if (lexgosignEnabled) {
                      <div class="col-md-9 pr-1">
                        <label class="small text-muted mb-1 d-block">Proveedor de firma</label>
                        <select
                          class="form-control form-control-sm"
                          [(ngModel)]="signatureProvider"
                          (ngModelChange)="onSignatureProviderChange()"
                          name="signatureProvider"
                        >
                          <option value="tufirma">TuFirma / e-cert</option>
                          <option value="lexgosign">CLM Sign</option>
                          <option value="docusign">DocuSign</option>
                        </select>
                      </div>
                      <div class="col-md-3 pl-1 text-right">
                        <a type="button" class="icon-doc" data-cy="upload-file" (click)="createSignature()"
                          [title]="
                            signatureProvider === 'lexgosign'
                              ? 'Enviar con CLM Sign'
                              : signatureProvider === 'docusign'
                                ? 'Enviar con DocuSign'
                                : 'Nueva firma'
                          ">
                          <i class="fas fa-plus"></i>
                        </a>
                      </div>
                    } @else {
                      <div class="col-md-12 text-right">
                        <a type="button" class="icon-doc" data-cy="upload-file" (click)="createSignature()"
                          title="Nueva firma">
                          <i class="fas fa-plus"></i>
                        </a>
                      </div>
                    }
                  </div>
                  @if (noteLoading) {
                    <div class="d-flex justify-content-center">
                      <table class="table-borderless" style="table-layout: fixed; width: 100%;">
                        <div class="spinner-border text-primary" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </table>
                    </div>
                  }
                  @if (!noteLoading && (signatureProvider === 'tufirma' || signatureProvider === 'docusign')) {
                    <div class="notes-container">
                      <signature-detail [path]="'trackvision/requirement/deletenote'" [signatures]="signatures"
                        [isNote]="true" (editNoteEmit)="createNote($event)" (deleteNoteEmit)="ondeleteNoteEmit($event)">
                      </signature-detail>
                      @if (!signatures || signatures.length <= 0) {
                        <app-without-registration
                          [icon]="'far fa-edit'"
                          [text]="signatureProvider === 'docusign' ? 'Sin firmas DocuSign' : 'Sin firmas'"
                        >
                        </app-without-registration>
                      }
                    </div>
                  }
                  @if (!noteLoading && lexgosignEnabled && signatureProvider === 'lexgosign') {
                    <div class="notes-container">
                      <app-lexgosign-detail
                        [envelopes]="lexgosignEnvelopes"
                        (refresh)="loadLexgosignEnvelopes()"
                      ></app-lexgosign-detail>
                      @if (!lexgosignEnvelopes || lexgosignEnvelopes.length <= 0) {
                        <app-without-registration [icon]="'far fa-edit'" [text]="'Sin firmas CLM Sign'">
                        </app-without-registration>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        <!-- Comunicación externa (portal) - abre modal o aviso si falta config -->
        @if (containsText('fas fa-comments')) {
          <div class="">
            <div class="div-accordion-link pointer-cursor" (click)="openPortalClientMessagesModal()">
              <div class="row">
                <div class="col-md-10 mt-2">
                  <i class="fa-comments fas" [class.text-warning]="hasPortalChatMisconfigured"></i>
                  &nbsp;Comunicación externa
                  @if (showPortalUnreadMessageBadge && !hasPortalChatMisconfigured) {
                    <span
                      class="badge portal-unread-msg-badge ml-2"
                      title="{{ portalChatUnreadCount }} mensaje(s) del cliente sin leer"
                      ><i class="fas fa-comment" aria-hidden="true"></i>{{ portalChatUnreadCount }}</span
                    >
                  }
                  @if (hasPortalChatMisconfigured) {
                    <small class="d-block text-warning mt-1">
                      {{ brand.messages.sidebarConfigIncomplete }}
                    </small>
                  }
                </div>
                <div class="col-md-2">
                  <button class="btn btn-link" type="button">
                    <i class="fas fa-chevron-down"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
          <!--MENSAJES-->
          @if (containsText('far fa-envelope')) {
            <div class="">
              <div class="div-accordion-link pointer-cursor" id="headingOne" data-toggle="collapse"
                data-target="#collapseSeven" aria-expanded="true" aria-controls="collapseSeven">
                <div class="row">
                  <div class="col-md-10 mt-2">
                    <i class="fa-envelope far"></i>
                    &nbsp;Enviar correo
                  </div>
                  <div class="col-md-2">
                    <button class="btn btn-link" type="button">
                      <i class="fas fa-chevron-down"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div id="collapseSeven" class="collapse" aria-labelledby="headingTwo" data-parent="#verticalAccordion">
                <div class="row">
                  <div class="col-md-12 ">
                    <div class="title-style">Mensaje nuevo</div>
                    <form #form="ngForm" (ngSubmit)="submitEmail(form)">
                      <div class="form-group gp">
                        <div class="row">
                          <div class="col-md-12 d-flex align-items-center justify-content-between">
                            <span class="text-form">Para:</span>
                            <input class="form-control para-style" name="para" #para="ngModel" [(ngModel)]="newEmail.email"
                              required pattern="^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}),?\s*){1,30}$"
                              (keydown.enter)="prevent($event)" />
                            <div class="button-cc" [style.visibility]="!cc ? 'visble': 'hidden'">
                              <button class="btn text-form" (click)="changeCc()">Cc</button>
                            </div>
                            <div class="button-cco" [style.visibility]="!cco ? 'visble': 'hidden'">
                              <button class="btn text-form" (click)="changeCco()">CCO</button>
                            </div>
                          </div>
                          <div class="col-md-12 d-flex align-items-center justify-content-between">
                            @if ((formSubmitted || para.dirty) && para.invalid) {
                              <ul class="text-danger list-unstyled">
                                @for (error of getValidationMessages(para); track error) {
                                  <li>
                                    {{error}}
                                  </li>
                                }
                              </ul>
                            }
                          </div>
                        </div>
                      </div>
                      @if (cc) {
                        <div class="form-group gp">
                          <div class="row">
                            <div class="col-md-12">
                              <span class="text-form">Cc:</span>
                              <input class="form-control input-cc" name="cc" #cc="ngModel" [(ngModel)]="newEmail.cc"
                                pattern="^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}),?\s*){1,30}$"
                                (keydown.enter)="prevent($event)" />
                              @if ((formSubmitted || cc.dirty) && cc.invalid) {
                                <ul class="text-danger list-unstyled">
                                  @for (error of getValidationMessages(cc); track error) {
                                    <li>
                                      {{error}}
                                    </li>
                                  }
                                </ul>
                              }
                            </div>
                          </div>
                        </div>
                      }
                      @if (cco) {
                        <div class="form-group gp">
                          <div class="row">
                            <div class="col-md-12">
                              <span class="text-form">CCO:</span>
                              <input class="form-control input-cc" name="cco" #cco="ngModel"
                                pattern="^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}),?\s*){1,30}$"
                                [(ngModel)]="newEmail.cco" (keydown.enter)="prevent($event)" />
                              @if ((formSubmitted || cco.dirty) && cco.invalid) {
                                <ul class="text-danger list-unstyled">
                                  @for (error of getValidationMessages(cco); track error) {
                                    <li>
                                      {{error}}
                                    </li>
                                  }
                                </ul>
                              }
                            </div>
                          </div>
                        </div>
                      }
                      <div class="form-group gp pt-2">
                        <div class="row">
                          <div class="col-md-12">
                            <span class="text-form">Asunto:</span>
                            <input class="form-control asunto-style" name="asunto" #asunto="ngModel"
                              [(ngModel)]="newEmail.subject" (keydown.enter)="prevent($event)" required />
                            @if ((formSubmitted || asunto.dirty) && asunto.invalid) {
                              <ul class="text-danger list-unstyled">
                                @for (error of getValidationMessages(asunto); track error) {
                                  <li>
                                    {{error}}
                                  </li>
                                }
                              </ul>
                            }
                          </div>
                        </div>
                      </div>
                      <div class="form-group pt-2">
                        <div class="row">
                          <div class="col-md-12 textarea-email">
                            <quill-editor [modules]="config" name="contenido" #contenido="ngModel"
                              [(ngModel)]="newEmail.content" required
                              [style]="{'min-height': '300px', 'height': '300px'}">
                            </quill-editor>
                            @if (formSubmitted) {
                              <div>
                                @if ((formSubmitted || contenido.dirty) && contenido.invalid) {
                                  <ul class="text-danger list-unstyled"
                                    >
                                    @for (error of getValidationMessages(contenido); track error) {
                                      <li>
                                        {{error}}
                                      </li>
                                    }
                                  </ul>
                                }
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                      <div class="form-group pt-2">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="text-form pb-2">Archivo</div>
                            <div class="checkbox-email">
                              <div class="col-md-12 textarea">
                                <input class="form-check-input" type="checkbox" [(ngModel)]="masterSelected"
                                  name="list_name" value="m1" (change)="checkUncheckAll()">
                              </div>
                              <label class="text-table center-text-email">Select all</label>
                            </div>
                            <div class="form-group gp">
                              <table class="table-borderless" style="table-layout: fixed; width: 100%;">
                                <colgroup>
                                <col span="1" style="width: 7%;">
                                <col span="1" style="width: 93%;">
                              </colgroup>
                              <tbody class="">
                                @for (file of newFiles; track file) {
                                  <tr>
                                    <td class="group-checkbox-email">
                                      <input class="position-static" type="checkbox" [(ngModel)]="file.isSelected"
                                        name="list_name" value="{{file.id}}" (change)="isAllSelected()">
                                    </td>
                                    <td class="text-table">{{file.filename}}</td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        @if (successMessage) {
                          <div class="form-group">
                            <div class="row">
                              <div class="col-md-12">
                                <ngb-alert class="mt-3" type="success" (close)="successMessage = ''">{{
                                successMessage }}</ngb-alert>
                              </div>
                            </div>
                          </div>
                        }
                        @if (errorMessage) {
                          <div class="form-group">
                            <div class="col-md-12">
                              <div class="col-md-12">
                                <ngb-alert class="mt-3" type="danger" (close)="errorMessage = ''">{{
                                errorMessage }}</ngb-alert>
                              </div>
                            </div>
                          </div>
                        }
                        <div class="col-md-12 text-bottom d-flex justify-content-center mt-3">
                          <button type="submit" class="btn btn-outline-primary  rounded-pill text-dark  font-weight-bold"
                            style="width: 120px;" [disabled]="form.invalid"
                            [class.btn-secondary]="formSubmitted && form.invalid">
                            @if (loading) {
                              <div>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Cargando...
                              </div>
                            }
                            @if (!loading) {
                              <span>
                                Enviar
                              </span>
                            }
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="text-form pb-2"></div>
                    </div>
                  </div>
                  @if (!noteLoading) {
                    <div class="notes-container pt-2">
                      <app-email-history [dataEmailHistory]="dataEmailHistory">
                      </app-email-history>
                      @if (dataEmailHistory.length == 0) {
                        <app-without-registration [icon]="'far fa-comment'"
                          [text]="'Sin Mensajes'">
                        </app-without-registration>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        <!--GASTOS-->
        @if (containsText('fas fa-money-bill-wave')) {
          <div class="">
            <div class="div-accordion-link pointer-cursor" id="headingOne" data-toggle="collapse"
              data-target="#collapseEight" aria-expanded="true" aria-controls="collapseEight">
              <div class="row">
                <div class="col-md-10 mt-2">
                  <i class="fa-money-bill-wave fas"></i>
                  &nbsp;Gastos
                </div>
                <div class="col-md-2">
                  <button class="btn btn-link" type="button">
                    <i class="fas fa-chevron-down"></i>
                  </button>
                </div>
              </div>
            </div>
            <div id="collapseEight" class="collapse" aria-labelledby="headingTwo" data-parent="#verticalAccordion">
              <br>
                <div class="col-md-12  cost-req">
                  <div class="row mb-1">
                    <div class="col-md-10">
                      <div class="title-style"></div>
                    </div>
                    <a class="col-xs-2 icon-plus" (click)="openModalToCreateCost(null)" type="button">
                      <div class="icon-doc">
                        <i class="fas fa-plus"></i>
                      </div>
                    </a>
                  </div>
                  @if (costLoading) {
                    <div class="d-flex justify-content-center">
                      <table class="table-borderless" style="table-layout: fixed; width: 100%;">
                        <div class="spinner-border text-primary" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </table>
                    </div>
                  }
                  @if (!costLoading) {
                    <div class="notes-container">
                      <app-cost-requirement [costs]="costs" (loadCosts)="onLoadCosts($event)" [requirementId]="requirementId">
                      </app-cost-requirement>
                      @if (costs.length <= 0) {
                        <app-without-registration [icon]="'fas fa-money-bill-wave'"
                          [text]="'Sin Gastos'">
                        </app-without-registration>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          <!--HONORARIOS-->
          @if (containsText('fas fa-money-bill-wave-alt')) {
            <div class="">
              <div class="div-accordion-link pointer-cursor" id="headingOne" data-toggle="collapse"
                data-target="#collapseNine" aria-expanded="true" aria-controls="collapseNine">
                <div class="row">
                  <div class="col-md-10 mt-2">
                    <i class="fa-money-bill-wave-alt fas"></i>
                    &nbsp;Honorarios
                  </div>
                  <div class="col-md-2">
                    <button class="btn btn-link" type="button">
                      <i class="fas fa-chevron-down"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div id="collapseNine" class="collapse" aria-labelledby="headingTwo" data-parent="#verticalAccordion">
                <br>
                  <div class="col-md-12  cost-req">
                    <div class="row mb-1">
                      <div class="col-md-10">
                        <div class="title-style"></div>
                      </div>
                      <a class="col-xs-2 icon-plus" (click)="openModalToCreateFee(null)" type="button">
                        <div class="icon-doc">
                          <i class="fas fa-plus"></i>
                        </div>
                      </a>
                    </div>
                    @if (costLoading) {
                      <div class="d-flex justify-content-center">
                        <table class="table-borderless" style="table-layout: fixed; width: 100%;">
                          <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </table>
                      </div>
                    }
                    @if (!costLoading) {
                      <div class="notes-container">
                        <app-cost-requirement [costs]="fee" (loadCosts)="onLoadCosts($event)" [requirementId]="requirementId">
                        </app-cost-requirement>
                        @if (fee.length == 0) {
                          <app-without-registration [icon]="'fas fa-money-bill-wave-alt'"
                            [text]="'Sin Honorarios'">
                          </app-without-registration>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            <!--HISTORIAL-->
            @if (containsText('fas fa-hourglass-half')) {
              <div class="">
                <div class="div-accordion-link pointer-cursor" id="headingOne" data-toggle="collapse"
                  data-target="#collapseTen" aria-expanded="true" aria-controls="collapseTen">
                  <div class="row">
                    <div class="col-md-10 mt-2">
                      <i class="fa-hourglass-half fas"></i>
                      &nbsp;Historial
                    </div>
                    <div class="col-md-2">
                      <button class="btn btn-link" type="button">
                        <i class="fas fa-chevron-down"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div id="collapseTen" class="collapse" aria-labelledby="headingTwo" data-parent="#verticalAccordion">
                  <br>
                    <div class="col-md-12  history-req">
                      <app-historical-requirement [historials]="logs" (loadHistoryLog)="onLoadHistoryLog($event)">
                      </app-historical-requirement>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
